"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteIds = exports.addIds = exports.mergeItem = exports.getHash = void 0;
var mapValues_1 = __importDefault(require("lodash/mapValues"));
var union_1 = __importDefault(require("lodash/union"));
var object_hash_1 = __importDefault(require("object-hash"));
function getHash(obj) {
    if (obj === undefined) {
        return "undefined";
    }
    return (0, object_hash_1.default)(obj);
}
exports.getHash = getHash;
function mergeItem(itemMap, items) {
    return items.reduce(function (prev, item) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[item.id] = item, _a));
    }, itemMap);
}
exports.mergeItem = mergeItem;
function addIds(idsMap, ids) {
    return (0, mapValues_1.default)(idsMap, function (currentIds) { return (0, union_1.default)(currentIds, ids); });
}
exports.addIds = addIds;
function deleteIds(idsMap, ids) {
    return (0, mapValues_1.default)(idsMap, function (currentIds) { return currentIds.filter(function (id) { return !ids.includes(id); }); });
}
exports.deleteIds = deleteIds;
